module.exports = __webpack_public_path__ + "static/media/img_approve.75b0d2c0.png";